import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import { Link as RouterLink } from "react-router-dom";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

// The legacy desktop ERP navbar (MegaNav + ERP GlobalSearch) was removed when the
// public-web ERP was decommissioned; staff work lives in staff-erp under /staff.
export default function Restricted() {
  return (
    <DashboardLayout>
      <MDBox py={3}>
        <Card>
          <MDBox p={3}>
            <MDBox display="flex" alignItems="center" gap={1} mb={1}>
              <Icon color="error">block</Icon>
              <MDTypography variant="h5" fontWeight="medium">
                Restricted
              </MDTypography>
            </MDBox>
            <MDTypography variant="body2" color="text">
              You don&apos;t have permission to view that page.
            </MDTypography>
          </MDBox>
          <Divider />
          <MDBox p={3} display="flex" gap={1} justifyContent="flex-end">
            <MDButton component={RouterLink} to="/" variant="outlined" color="secondary">
              Home
            </MDButton>
            <MDButton component={RouterLink} to="/account" variant="gradient" color="info">
              My account
            </MDButton>
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

